module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-SemiExt.113cec8.ttf";